import { localizedMedia, localizedLink } from '../i18n/resources';
import { t } from '../i18n';
import {React, useEffect, useState, useRef} from "react";
import Navbar from "./Navbar";
import Package from "./Package";
import Footer from "./Footer";
import { Parallax } from 'react-parallax';
import InnerModal from "./InnerModal";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import plBgimgOriginal from "../img/pl-bgimg.png";
import plimgOriginal from "../img/pl-img.png";
import uromobOriginal from "../img/urodziny_mobile.png";
import cieniekOriginal from "../img/cieniek.png";
import urotextOriginal from "../img/urodziny_tekst.svg";
import luroprezkupOriginal from "../img/kuponuro.png";

const plBgimg = localizedMedia(plBgimgOriginal, "pl-bgimg.png");
const plimg = localizedMedia(plimgOriginal, "pl-img.png");
const uromob = localizedMedia(uromobOriginal, "urodziny_mobile.png");
const cieniek = localizedMedia(cieniekOriginal, "cieniek.png");
const urotext = localizedMedia(urotextOriginal, "urodziny_tekst.svg");
const luroprezkup = localizedMedia(luroprezkupOriginal, "kuponuro.png");

const Urodziny = (props) => {
    const myRef = useRef(null)
  const {service, services} = props;
  let pricePart = <span>{t("od x zł")}</span>;
  const executeScroll = () => myRef.current.scrollIntoView();
  let resBut = <button className="nav-res-service" onClick={executeScroll}>{t("Zarejestruj się")}</button>;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);

  function IframeLoad() {
    console.log('iframe load');
    let myiFrame = document.getElementById("myiFrame");
    console.log(myiFrame);
  }

  const [open, setOpen] = useState(false);
  const baseImgUrl = "https://test.cms.soft99.eu";
  const parallaxBgImg = plBgimg;
  let mediaBox = 
      <div className="service-media-part">
        <div className="service-media-part-single">
          <img src={plimg} alt=""></img>
        </div>
        <div className="row services-packages-row plloginbox">
                <p className="lsbut lsbutreg"><a href={localizedLink("https://forms.gle/JCU5JaMPN3n9EkDG6")} target="_blank">{t("Zapisz się na rajd!")}</a></p>
              </div>
      </div>

  return(
        <section>
          <Modal open={open} onClose={() => setOpen(false)} center>
            <InnerModal setOpen={setOpen} service={service && service}/>
          </Modal>
          <header>
            <Navbar services={services} service={service} />
          </header>
          <Parallax strength={500} bgClassName="parallax-bg-services">
          <div className="service-top-hero service-top-hero-uro-master">

            <div className="container conturo">
              <div className="row">
                <div className="col-lg-5">
                </div>
                <div className="col-lg-7">
                  <img className="urouro" src={uromob} alt=""></img>
                </div>
              </div>
            </div>
            <div className="service-top-hero-tag service-top-hero-uro">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <p>{t("Świętujmy")}<br/>{t("razem!")}</p>
                    <img className="urotext" src={urotext} alt=""></img>
                  </div>
                </div>
              </div>
            </div>
            <img className="cieniekuro" src={cieniek} alt=""></img>
          </div>
          </Parallax>
          <div className="service-main-content luromaincontent">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <p className="luromaintitle"><b>{t("Świętuj razem z nami i weź udział ")}<br className="lurohidemoonmobile"/>{t("w wyjątkowych wydarzeniach!")}</b></p>
                </div>
              </div>
              <div className="row luromorebottomspace">
                <div className="col-lg-6">
                  <p className="luro_data">10 - 11.06</p>
                  <p className="luro_title">{t("Finał rajdu \"ROUTE99\" w Soft99 Garage.")}</p>
                  <p className="luro_desc">{t("Podziwiaj wyjątkową kolekcję klasycznych, nietuzinkowych aut, które wystartują z Classic Remise Berlin, by swoją trasę zakończyć w samym sercu Poznania, w Soft99 Garage!")}</p>
                  <p className="luro_red_data">10.06 | 16:00</p>
                </div>
                <div className="col-lg-6">
                  <p className="luro_data">17.06</p>
                  <p className="luro_title">{t("Urodzinowy Zlot w Soft99 Garage")}</p>
                  <p className="luro_desc">{t("Bądź częścią niezwykłego wydarzenia tworzonego przez fanów aut klasycznych, zobacz przekrój motoryzacyjnej historii.")}</p>
                  {/* <p className="luro_red_data">17.06 (17:00)</p> */}
                  <p className="luro_red_data">17.06 | 17:00</p>
                </div>
                <div className="col-lg-6">
                  <p className="luro_data">24.06</p>
                  <p className="luro_title">{t("Poznańska edycja rajdu \"ROUTE99\"")}</p>
                  <p className="luro_desc">{t("Weź udział w wyjątkowej przygodzie za kółkiem własnego auta. Pokonaj wspólnie z nami trasę z Soft99 Garage do Rakojadów, zaliczaj kolejne przystanki, wykonuj zadania, odbieraj nagrody i baw się z innymi uczestnikami.")}</p>
                  {/* <p className="luro_red_data">24.06 (10:00)</p> */}
                  <p className="luro_red_data">24.06 | 10:00</p>
                  <p className="lsbut lsbutreg lurozapis"><a href={localizedLink("https://forms.gle/JCU5JaMPN3n9EkDG6")} target="_blank">{t("Zapisz się na rajd!")}</a></p>
                  
                </div>
                <div className="col-lg-6">
                  <p className="luro_data">30.06 - 1.07</p>
                  <p className="luro_title">{t("Dni otwarte Soft99 Optyka")}</p>
                  <p className="luro_desc">{t("Wpadnij do nas i poznaj inne oblicze japońskiej kosmetyki. Przetestuj rozwiązania do okularów od Soft99 i sprawdź potęgę japońskiej inżynierii chemicznej w służbie codzienności każdego człowieka")}</p>
                  {/* <p className="luro_red_data">30.06 (16:00-19:00)</p>
                  <p className="luro_red_data">1.07 (11:00- 14:00)</p> */}
                  <p className="luro_red_data">30.06 | 16:00-19:00</p>
                  <p className="luro_red_data">1.07 | 11:00- 14:00</p>
                </div>
              </div>
              <div className="row lurohidemoonmobile">
                <div className="col-lg-6 luropreztextcont">
                  <p className="luropreztit">{t("Nie ma urodzin bez prezentów!")}</p>
                  <p className="luroprezdesk">{t("Nie ma urodzin bez prezentów, a jako uczestnik naszego programu lojalnościowego, jeden otrzymasz od nas. W czerwcu, do każdej usługi w Soft99 Garage odbierzesz ")}<b>{t("Wash Mist ZA DARMO!")}</b></p>
                </div>
                <div className="col-lg-6 luroprezimgcont">
                  <img className="luroprezimg" src={luroprezkup}></img>
                </div>
              </div>
              <div className="row lurohidemoondeskt">
                <div className="col-lg-12">
                  <p className="luropreztit">{t("Nie ma urodzin bez prezentów!")}</p>
                  <img className="luroprezimg" src={luroprezkup}></img>
                  <p className="luroprezdesk">{t("Nie ma urodzin bez prezentów, a jako uczestnik naszego programu lojalnościowego, jeden otrzymasz od nas. W czerwcu, do każdej usługi w Soft99 Garage odbierzesz ")}<b>{t("Wash Mist ZA DARMO!")}</b></p>
                </div>
              </div>            
            </div>
          </div>
          <Footer />
        </section>
    )
};

export default Urodziny;